module.exports = __webpack_public_path__ + "img/e11561b.png";